 import React from 'react'
import { useEffect, useState, useRef, createRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryGridAr from "../components/EntryGridAr";
import EntrySetting from "../components/EntrySetting";
import EntryRemarks from "../components/EntryRemarks";
import EntryImages from "../components/EntryImages";
import EntryFiles from "../components/EntryFiles";
import EntryBase from "../components/EntryBase";
import DropZone from "../components/DropZone";
import Headline from "../components/Headline";
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import {
    isEmpty, getglobaldata, CellType, Getstorage, Savestorage, DeepCopy, getWindowDimensions, setglobaldata, Loadstorage,
    getformid, getcontroller, getsubkey, initializedata, isEnabled, NumConv, GetDesitRound, GetRound, DicVal
} from '../modules/appLibrary';
import { cfFileUpload, cfNewUploadFile, cfMargeUploadFiles } from '../modules/commodule';
import { setimagelist } from '../modules/imagedlgstore';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import EntryLayout from '../components/EntryLayout';
import { changestatus, listtabs, entrytriggercall, setgridlist, listoption, readonly } from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup } from '../modules/toolpanelstore';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

export const RawM = props => {

    const panelsdef = [];
    const G_id = { BASE: "0", KHDM: "1", FZK: "2", SZI: "3", IMAGE: "pic", FILE: "file", NB: "nb", PL: "pl" }
    const SZIType = ["100", "101", "110", "111", "112", "113"];     //素材
    const FZKType = ["102", "103", "104", "120", "121", "122", "123"];     //附属
    const FZIType = ["102", "103", "104", "120", "131", "122", "133"];     //副資材
    const TRANTYPE = { NONE: "0", PROG: "1"}

    const primarykeys = ["KHD_DENNO", "KHDM_DENNO","FRH_DENNO","FRHM_DENNO"];
    const formid = getformid("RawM", props.location.search);
    const controller = getcontroller("RawM", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const menuinfo = useSelector(state => state.form.menuinfo);
    const formListOption = useSelector(state => state.form.listoption);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);

    const baseref = useRef();
    const AGRef = useRef();
    const fnc = useRef();
    const EntrybodyRef = useRef(null);
    const locationstate = useRef(null);    //遷移State
    const transinfo = useRef(null);    //遷移情報

    const CELLTYPE = CellType();

    const formstatus = useSelector(state => state.form.status);
    const entrylock = useSelector(state => state.form.entryformlock);
    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);     //全カラム情報
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState(null);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [update, setUpdata] = useState(false);
    const [isDragActive, setIsDragActive] = useState(false);
    const [entryonly, setentryonly] = useState(false);
    const gridlist = useSelector(state => state.form.gridlist);

    const dispatch = useDispatch();
    const search = useLocation().search;
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);
    const scrollRef = useRef(null);
    const listoptionRef = useRef('0');        //0:原材料 1:附属 2:副資材

    const gridapiRefs = useRef([]);
    const gridcolapiRefs = useRef([]);
    const griddataRefs = useRef([]);
    const gridcolRefs = useRef([]);

    //データ
    const entrydataRef = useRef(null);
    const imageRef = useRef(null);
    const fileRef = useRef(null);         //ファイル  

    function SetGridData(panel, data) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        griddataRefs.current[gidx].current = data;
    }
    function GridData(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return griddataRefs.current[gidx].current;
    }
    function SetGridColDef(panel, coldef) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridcolRefs.current[gidx].current = coldef;
    }
    function SetGridApi(panel, api) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridapiRefs.current[gidx].current = api;
    }
    function GridApi(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return gridapiRefs.current[gidx].current;
    }
    function SetGridColApi(panel, api) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridcolapiRefs.current[gidx].current = api;
    }
   function GridColApi(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return gridcolapiRefs.current[gidx].current;
    }

    function OptID() {
        switch (listoptionRef.current) {
            case "0": return G_id.KHDM;
            case "1": return G_id.FZK;
            case "2": return G_id.SZI;
        }
    }
    const actionurl = {
        "getlist": "RawM/GetListData",
    }

    //動作抑止
    const suppressaction = [
        { type: "*", action: "INSERT" },
        { type: "*", action: "UPDATE" },
        { type: "2", action: "COPY FORM" },
        { type: "3", action: "COPY FORM" },
        { type: "4", action: "COPY FORM" },
        { type: "5", action: "COPY FORM" },
        ];

    const navmenu = [
        { status: "ENTRY FORM", menuid: "print1", icon: "print", label: "素材発注書発行"},
        { status: "ENTRY FORM", menuid: "print2", icon: "print", label: "附属発注書発行" },
        { status: "ENTRY FORM", menuid: "print3", icon: "print", label: "副資材発注書発行" },
        { status: "ENTRY FORM", menuid: "print4", icon: "print", label: "品質表示出荷依頼書発行" },
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
        { status: "VIEW", menuid: "sep" },
        { status: "VIEW", menuid: "print1", icon: "print", label: "素材発注書発行" },
        { status: "VIEW", menuid: "print2", icon: "print", label: "附属発注書発行" },
        { status: "VIEW", menuid: "print3", icon: "print", label: "副資材発注書発行" },
        { status: "VIEW", menuid: "print4", icon: "print", label: "品質表示出荷依頼書発行" },
    ]

    function entryNavMenu() {
        const prefix = listoptionRef.current === "0" ? "KHD" : "FRH";
        if (entrydataRef.current?.[`${prefix}_REQFLG`] !== "1") return navmenu;

        return [
            { status: "ENTRY FORM", menuid: "withdraw", icon: "cancel", label: "申請解除" },
            { status: "ENTRY FORM", menuid: "sep" },
            ...navmenu
        ];
    }

    function rerender() {
        setUpdata(update ? false : true);
    }
    function onDragEnter(e) {
        if (entrylock) return;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setIsDragActive(true);
        }
    };
    function FileDropClose() {
        setIsDragActive(false);
    }

    //主キー取得
    function primarykey() {
        if (isEmpty(columninfo)) return "";
        if (!columninfo.some(e => e.primarykey)) return "";
        return columninfo.find(e => e.primarykey).columnid;
    }

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;
        //ListTabを取得
        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    setpanel(data.panels);
                    dispatch(setentrypanel({
                        layouts: data.layouts, prelayout: data.prelayout,
                        initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                        fitColumn: data.fitColumn
                    }));
                    setcolumninfo(data.colinfo);
                    setcolumns(data.columns);
                    let fields = data.colinfo.filter(e => e.logpid === G_id.BASE);
                    settextfieldsall(fields);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    fnc.current.initMaster(data.master);

                    let idx = 0;
                    let glist = [];
                    data.panels.filter(e => e.grid).forEach(function (panel) {
                        gridapiRefs.current[idx] = createRef();
                        gridcolapiRefs.current[idx] = createRef();
                        griddataRefs.current[idx] = createRef();
                        gridcolRefs.current[idx] = createRef();
                        glist.push({id:panel.id, type:panel.type, index:idx});
                        idx++;
                        let t = data.colinfo.find(e => e.logpid === "T" + panel.id)
                        if(!isEmpty(t)) {
                            //TOTAL用REF作成
                            gridapiRefs.current[idx] = createRef();
                            gridcolapiRefs.current[idx] = createRef();
                            griddataRefs.current[idx] = createRef();
                            gridcolRefs.current[idx] = createRef();
                            glist.push({ id: "T" + panel.id, type: t.type, index: idx });
                            idx++;
                        }
                    });

                    dispatch(setgridlist(glist));

                    if (data.prelayout) {   //レイアウト復元
                        RestoreLayout(data.panels, fields);
                    }

                    //遷移state取得
                    let state = props.location.state;   //history.push
                    if (isEmpty(state) && !isEmpty(window.history.state)) {
                        if ("status" in window.history.state) {
                            //go back
                            state = window.history.state;
                        }
                    }
                    let key = search.split("key=")[1];
                    if (isEmpty(state) && !isEmpty(key)) {
                        let calldata = Loadstorage(key);
                        state = calldata?.state;  //他画面からの連携情報取得
                        if (!isEmpty(state)) {
                            //連携されてきた場合
                            listoptionRef.current = resolveListOptionFromState(state);
                        }
                    }
                    locationstate.current = state;
                    transinfo.current = null;
                    if (!isEmpty(state)) {
                        listoptionRef.current = resolveListOptionFromState(state);
                        transinfo.current = Object.assign({}, state);     //LIST情報保持
                        if ("code" in state) {
                            dispatch(changestatus(state.code === "" ? "NEW FORM" : "ENTRY FORM"));
                        }
                    }
                    fnc.current.wait(false);
               }
            });
    }, [search]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
        setsectionclose(menuinfo.ctrls.indexOf("SECCLOSE") !== -1); //セクションCLOSEボタン
    }, [menuinfo]);

    useEffect(() => {
        if (formstatus === "COPY FORM") {
            columninfo.filter(e => e.copyclear).forEach(function (col) {
                entrydataRef.current[col.columnid] = "";
            });
            rerender();
        }
        if (formstatus === "VIEW") {
            var type = baseref.current.ListType();
            if (type === "0" || type === "1") {
                var newmenu = entryNavMenu().filter(e => e.menuid !== 'print2' && e.menuid !== 'print3' && e.menuid !== 'print4');
                baseref.current?.ChangeNavmenu(newmenu);
            }
            if (type === "2" || type === "3") baseref.current?.ChangeNavmenu(entryNavMenu().filter(e => e.menuid !== 'print1' && e.menuid !== 'print3' && e.menuid !== 'print4'));
            if (type === "4" || type === "5") baseref.current?.ChangeNavmenu(entryNavMenu().filter(e => e.menuid !== 'print1' && e.menuid !== 'print2'));

        }

    }, [formstatus]);

    function resolveListOptionFromState(state) {
        const historyType = String(DicVal(state, "historyType", "") ?? "").trim();
        if (historyType === "0" || historyType === "1" || historyType === "2") return historyType;
        const mode = String(DicVal(state, "mode", "") ?? "").trim();
        if (mode === "fuzoku_bulk_order") return "1";
        if (mode === "fukushizai_bulk_order") return "2";
        return "0";
    }

    function TryCallShow() {
        if (isEmpty(locationstate.current)) {
            return;
        }
        let call = true;
        for (let i = 0; i < gridlist.length; i++) {
            if (EmptyPanel(gridlist[i].id, gridlist[i].type)) continue;
            if (isEmpty(GridApi(gridlist[i]))) {
                call = false; break;
            }
        }
        //遷移表示
        if (call) callshow();
    }
    function Transtype() {
        if (isEmpty(transinfo.current)) return TRANTYPE.NONE;
        if (transinfo.current.accepttype === "WorkProgMgr") return TRANTYPE.PROG;   //作業・進捗管理
        return TRANTYPE.NONE;
    }

   //遷移state状態表示
    function callshow() {
        if (locationstate.current.code !== "") {
            if (Transtype() === TRANTYPE.PROG) {    //作業・進捗管理
                document.title += " <作業・進捗管理>";
                baseref.current.NotShowStatus(true);    //CANCEL無効
                dispatch(readonly({ readonly: true, ctrls: menuinfo.ctrls }));
          }
            Show(undefined, locationstate.current.code)
        } else {
            if (!isEmpty(locationstate.current.acceptno)) {
                AcceptAction(locationstate.current.acceptno);
            }
        }
        locationstate.current = null;   //最初の１度のみ
    }
    //受入処理
    function AcceptAction(value) {
        var state = locationstate.current;
        var others = null;
        if (!isEmpty(state.detail)) others = [{ ...state.detail, accepttype: state.accepttype }];
        else if (!isEmpty(state.mode)) others = [{ accepttype: state.accepttype }];
        if (state.accepttype === 'MDtounyu:D_TNY2') value = [value];    //MD投入表
        listoptionRef.current = resolveListOptionFromState(state);
        const requestType = !isEmpty(state.mode) ? state.mode : state.accepttype;
        fnc.current.postaxios('rawm/GetAccept', { type: requestType, "keys": value, "colinfo": columninfo, addinfo: others },
            {
                onSuccess: function (data) {
                    try {
                        const beforeData = entrydataRef.current;
                        fnc.current.margeMaster(data.master);
                        entrydataRef.current = keepListOptionValue(data.data, beforeData);
                        //行データ
                        for (let i = 0; i < gridlist.length; i++) {
                            if (!isEmpty(data.detail[gridlist[i].type])) {
                                SetGridData({ id: gridlist[i].id }, data.detail[gridlist[i].type]);
                                if (existTotal(gridlist[i].id)) {
                                    //合計セット
                                    SetTotalData(gridlist[i].id, data.detail[gridlist[i].type], true);
                                }
                            }
                        }
                        gridlist.filter(e => e.id === G_id.PL).forEach(function (l) {
                            //PL行データ
                            SetGridData(l, fnc.current.PLRowData(data.data, l.type, columninfo));
                        });

                        setKikakueColumnName(data.data["KHD_HACHUTANI"]);
                        showpanel('0', '101', (data.data['KHD_SHOKUFLG'] === '1'));
                        let newmenu = entryNavMenu().filter(e => e.menuid !== 'print2' && e.menuid !== 'print3' && e.menuid !== 'print4');
                        baseref.current?.ChangeNavmenu(newmenu);

                        rerender();
                        fnc.current.wait(false);
                    } catch (error) {
                        console.log(error);
                        fnc.current.wait(false);
                    }

                },
                errmsg: "処理に失敗しました"
            }
        )
    }

    function onGridReady(param, panel) {
        SetGridApi(panel, param.api);
        SetGridColApi(panel, param.api);

        //遷移表示
        TryCallShow();
    }
    function onFirstDataRendered(param, panel) {
        // SetGridApi(panel, param.api);
        // SetGridColApi(panel, param.api);

        // //遷移表示
        // TryCallShow();
    }
    function Show(data, pushcode, listoption) {
        let code = "";
        if (data === undefined) {
            if (!isEmpty(pushcode)) {   //history.push
                code = pushcode;
                setedittingcode(code);
            } else {
                code = edittingcode;    //再表示
            }
        } else {
            setglobaldata("entryrowdata",data);
            if (data !== null) {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (data[primarykeys[i]]) {
                        code = data[primarykeys[i]]; break;
                    }
                }
            }
            setedittingcode(code);
        }
        if (!isEmpty(listoption)) listoptionRef.current = listoption; 
        if (isEmpty(columninfo)) return false;    //読み込み前
        clearform(code === "");
       //データ読み込み
        LoadData(code);
        return true;
    }

    //リストレイアウト適用
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e=>e.type !==type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
   }

    function kikakueColumnName(mode, value) {
        switch (value) {
            case "1":
                return mode === 0 ? "規格長(m)" : "規格巾(m)";
            case "2":
                return mode === 0 ? "規格長(yd)" : "規格巾(yd)";
            default:
                return mode === 0 ? "規格長":"規格巾";
        }
    }

    function changeBaseColumnName(columnid, columnnm) {
        const updateColumns = (fields) => {
            if (isEmpty(fields)) return fields;
            const idx = fields.findIndex(e => e.columnid === columnid);
            if (idx === -1 || fields[idx].columnnm === columnnm) return fields;
            const newfields = DeepCopy(fields);
            newfields[idx].columnnm = columnnm;
            return newfields;
        };
        settextfieldsall(prev => updateColumns(prev));
        settextfields(prev => updateColumns(prev));
    }

    function setKikakueColumnName(value) {
        changeBaseColumnName("KHD_KIKAKUE", kikakueColumnName(0, value));
        changeBaseColumnName("KHD_KIKAKU", kikakueColumnName(1, value));
    }
    function setSyukasakiMaster(value) {
        var dataid = value === "1" ? "V_SUPPLIER" : "V_FACTORY";
        const updateColumns = (fields) => {
            if (isEmpty(fields)) return fields;
            const idx = fields.findIndex(e => e.columnid === "FRH_SYUKASAKICD");
            if (idx === -1 || fields[idx].dataid === dataid) return fields;
            const newfields = DeepCopy(fields);
            newfields[idx].dataid = dataid;
            return newfields;
        };
        settextfieldsall(prev => updateColumns(prev));
        settextfields(prev => updateColumns(prev));
    }

    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let p = newpanel.find(e => e.id === id && e.type === type);
        p.hide = !show;
        setpanel(newpanel);
    }
    function SaveColumnInfo() {
        if (isEmpty(columninfo)) return [];

        return columninfo.filter(col => {
            if (isEmpty(col)) return false;

            if (col.logpid === G_id.BASE) {
                return panel.some(p => p.id === G_id.BASE && p.type === col.type && !panelhidden(p));
            }

            if (!isEmpty(col.logpid) && col.logpid.startsWith("T")) {
                return panel.some(p => p.id === col.logpid.substring(1) && !panelhidden(p));
            }

            if (panel.some(p => p.id === col.logpid && !panelhidden(p))) return true;
            if (panel.some(p => p.type === col.type && !panelhidden(p))) return true;

            return false;
        });
    }
    function GridPanelHidden(panelInfo) {
        if (isEmpty(panelInfo)) return false;
        let target = panel.find(p => p.id === panelInfo.id && p.type === panelInfo.type);
        if (!isEmpty(target)) return panelhidden(target);
        if (!isEmpty(panelInfo.id) && panelInfo.id.startsWith("T")) {
            let parent = panel.find(p => p.id === panelInfo.id.substring(1));
            if (!isEmpty(parent)) return panelhidden(parent);
        }
        return false;
    }
    function DetailSaveColumns(panelInfo, savecolinfo) {
        if (isEmpty(panelInfo) || isEmpty(savecolinfo)) return [];
        return savecolinfo.filter(col =>
            !isEmpty(col) &&
            col.type === panelInfo.type &&
            col.columnid !== "rowid" &&
            col.saveed !== false
        );
    }
    function IsMeaningfulDetailValue(value, col) {
        if (!isEmpty(col) && col.datatype === CELLTYPE.NUM) {
            return NumConv(value) !== 0;
        }
        return !isEmpty(value);
    }
    function IsMeaningfulDetailRow(row, savecols) {
        if (isEmpty(row) || isEmpty(savecols)) return false;

        let targetcols = savecols.filter(col =>
            !col.locked &&
            isEmpty(col.formula) &&
            !col.primary &&
            !col.primarykey
        );
        if (targetcols.length === 0) targetcols = savecols;

        return targetcols.some(col => IsMeaningfulDetailValue(row[col.columnid], col));
    }
    function SaveDetailRows(panelInfo, savecolinfo) {
        const savecols = DetailSaveColumns(panelInfo, savecolinfo);
        if (isEmpty(savecols)) return [];

        const currentrows = GridData(panelInfo) || [];
        return currentrows.filter(row => IsMeaningfulDetailRow(row, savecols));
    }
    function keepListOptionValue(target, source) {
        if (isEmpty(target)) return target;
        if (isEmpty(formListOption) || formListOption.length === 0) return target;
        let newdata = { ...target };
        formListOption.forEach(option => {
            if (isEmpty(option.columnid)) return;
            if (!isEmpty(source) && source[option.columnid] !== undefined) {
                newdata[option.columnid] = source[option.columnid];
                return;
            }
            if (option.headerfix === 1) {
                newdata[option.columnid] = listoptionRef.current;
            }
        });
        return newdata;
    }
    // スクロール位置を保存する
    function saveScrollPos() {
        scrollRef.current = EntrybodyRef.current.scrollTop;
    }
    // スクロール位置を復元する
    function restoreScrollPos() {
        try{
            if (scrollRef.current) EntrybodyRef.current.scrollTop = scrollRef.current;
        }catch{ }
    }
    //行データ保持
    function storeRowData(panel) {
        if (panel === undefined) {
            for (let i = 0; i < gridlist.length; i++) {
                SetGridData(gridlist[i], AGRef.current.GetDatasource(GridApi(gridlist[i])));
            }
        } else {
            SetGridData(panel, AGRef.current.GetDatasource(GridApi(panel)));
        }
    }

    function Jump(id, type) {
        let offset = 0;
        var panelid = "basepanel" + type;
        if (id === G_id.IMAGE) panelid = 'imagepanel';
        if (id === G_id.FILE) panelid = 'fileGrid';
        if (id === G_id.NB) panelid = 'remarkspanel' + type;
        if (isEmpty(type)) {
            type = tabletype(id);
        }
        if (panel.some(e => e.id === id && e.type === type && e.grid)) {
            panelid = fnc.current.GridID({ id: id, type: type });
        }
        let elem = document.getElementById(panelid);
        if (isEmpty(elem)) return;
        offset = elem.offsetTop - 50;
        EntrybodyRef.current.scrollTop = offset;
    }


    function MenuAction(action, finallycallback) {
        LayoutSaveStorage();   //現在レイアウト保持
        if (action === 'save') Save(finallycallback);
        if (action === 'delete') Delete(finallycallback);
        if (action === "clear") clearform(true);
        if (action === 'linkfield') {
            let col = textfields.find(e => e.columnid === finallycallback.field && (isEmpty(finallycallback.type)?true:e.type === finallycallback.type));
            if (col === undefined) return;
            if (col.logpid == "0") {    //基本情報
                let key = finallycallback.field + "_" + col.type;
                document.getElementById(key).focus();
                document.getElementById(key).select();
                Jump(G_id.BASE, col.type);
                return;
            }
            let logpid = col.logpid;
            Jump(logpid);
            AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, GridApi({ id: logpid }));
        }
        if (action === 'withdraw') {    //申請解除
            const isMaterial = listoptionRef.current === '0';
            const prefix = isMaterial ? "KHD" : "FRH";
            const requestFlag = `${prefix}_REQFLG`;
            const approvalFlag = `${prefix}_SYNFLG1`;
            if (entrydataRef.current[requestFlag] !== '1') {
                fnc.current.warnmsg("このデータは申請されていません");
                return;
            }
            if (entrydataRef.current[approvalFlag] === '2') {
                fnc.current.warnmsg("承認済のデータは変更不可です");
                return;
            }
            if (entrydataRef.current[approvalFlag] === '3') {
                fnc.current.warnmsg("却下のデータは変更不可です");
                return;
            }
            let msg = "申請解除します。宜しいでしょうか？";
            fnc.current.confmsg(msg, () => exec());
            function exec() {
                fnc.current.postaxios('rawm/CancelApp', { "code": edittingcode, type: listoptionRef.current },
                    {
                        onSuccess: function (data) {
                            // 申請状態の表示値・メニューを最新化するため、解除後のデータを再取得します。
                            LoadData(edittingcode);
                        },
                        errmsg: "処理に失敗しました"
                    }
                )
            }
        }
        if (action === "print1") {  //素材発注書発行
            let code = [];
            if (formstatus === "ENTRY FORM") {
                //承認済の場合のみ可能
                if (entrydataRef.current["KHD_SYNFLG1"] !== '2') {
                    fnc.current.warnmsg("承認がされていない為発行できません");
                    return;
                }
                code = [edittingcode];
            } else {
                let param = baseref.current?.GetSelectrowdata();
                if (param.length === 0) {
                    fnc.current.warnmsg("対象データを選択してください");
                    return;
                }
                for (let i = 0; i < primarykeys.length; i++) {
                    if (primarykeys[i] in param[0]) {
                        for (let j = 0; j < param.length; j++) {
                            if (param[j]["KHD_SYNFLG1"] !== '2') {
                                fnc.current.warnmsg("承認がされていないデータが選択されています");
                                return;
                            }
                            code.push(param[j][primarykeys[i]]);
                        }
                        break;
                    }
                }
            }
            if (code.length === 0) return;
            fnc.current.postaxios('SozaiHachuShoReport/Generate', { controller: controller, id: action, keys: code },
                {
                    onSuccess: function (data) {
                        let params = {
                            "excelfile": data.returnData["filename"],
                            "dnfile": data.returnData["dnfile"]
                        }
                        fnc.current.filedownload("excel/ExcelDownload", params);
                        fnc.current.wait(false);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
            return;
        }
        if (action === "print2" || action === "print3" || action === "print4") {  //附属発注書 副資材発注書 品質表示出荷依頼書発行
            let code = [];
            if (formstatus === "ENTRY FORM") {
                //承認済の場合のみ可能
                if (entrydataRef.current["FRH_SYNFLG1"] !== '2') {
                    fnc.current.warnmsg("承認がされていない為発行できません");
                    return;
                }
                code = [edittingcode];
            } else {
                let param = baseref.current?.GetSelectrowdata();
                if (param.length === 0) {
                    fnc.current.warnmsg("対象データを選択してください");
                    return;
                }
                for (let i = 0; i < primarykeys.length; i++) {
                    if (primarykeys[i] in param[0]) {
                        for (let j = 0; j < param.length; j++) {
                            if (param[j]["FRH_SYNFLG1"] !== '2') {
                                fnc.current.warnmsg("承認がされていないデータが選択されています");
                                return;
                            }
                            code.push(param[j][primarykeys[i]]);
                        }
                        break;
                    }
                }
            }
            if (code.length === 0) return;
            var url = "";
            if (action === "print2") url = "FuzokuHachuShoReport/Generate";
            if (action === "print3") url = "FukushizaiHacchuShoReport/Generate";
            if (action === "print4") url = "QualityLabelShippingRequestReport/Generate";
            fnc.current.postaxios(url, { controller: controller, id: action, keys: code },
                {
                    onSuccess: function (data) {
                        let params = {
                            "excelfile": data.returnData["filename"],
                            "dnfile": data.returnData["dnfile"]
                        }
                        fnc.current.filedownload("excel/ExcelDownload", params);
                        fnc.current.wait(false);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
            return;
        }
        if (action === "datacall1" || action === "datacall2") {
            //承認済の場合のみ可能
            if (entrydataRef.current["KHD_SYNFLG1"] !== '2') {
                fnc.current.warnmsg("承認がされていない為実行できません");
                return;
            }
            fnc.current.warnmsg("未実装");
        }
    }
    function Save(finallycallback, nocheck) {
        const saveData = BuildSaveData(nocheck);
        if (saveData === null) return;

        // 副資材のみ、初回保存時に登録前の警告チェックを行う。
        // OK または警告なしの場合は nocheck=true で再実行し、WarningCheck を通さずに登録する。
        if (!nocheck && listoptionRef.current === "2") {
            fnc.current.postaxios("rawm/WarningCheck", saveData.paramdata,
                {
                    onSuccess: function (data) {
                        if (!isEmpty(data.warning) && data.warning.length !== 0) {
                            const msgs = data.warning.map(item => item.message);
                            fnc.current.confmsg(msgs, () => Save(finallycallback, true), () => fnc.current.wait(false));
                            fnc.current.wait(false);
                        } else {
                            Save(finallycallback, true);
                        }
                    },
                    errmsg: "警告確認に失敗しました"
                }
            );
            return;
        }

        SaveEntry(finallycallback, saveData.paramdata, saveData.newfiles);
    }

    function BuildSaveData(nocheck) {
        var newfiles = (formstatus === "ENTRY FORM" ? [] : cfNewUploadFile(imageRef, fileRef)); //v1.4
        if (newfiles.length > 10) {
            fnc.current.warnmsg("新規登録できるアップロードファイル数は10までです。");
            return null;
        }
        storeRowData();
        const savecolumninfo = SaveColumnInfo();
        SetPLData();    //PL行データをentrydataRefにセット
        var detail = {};
        for (let i = 0; i < gridlist.length; i++) {
            if (gridlist[i].id === G_id.PL) continue;
            if (GridPanelHidden(gridlist[i])) continue;
            detail[gridlist[i].type] = SaveDetailRows(gridlist[i], savecolumninfo);
        }
        //有効なパネル情報のみセット
        var data = entrydataRef.current;
        // if (listoptionRef.current === "0" && isEmpty(entrydataRef.current["KHD_BRDCD"])) {
        //     const brandCode = DicVal(
        //         entrydataRef.current,
        //         "KHD_BRDCd",
        //         DicVal(entrydataRef.current, "BRDCd", DicVal(entrydataRef.current, "BRD_Code", ""))
        //     );
        //     entrydataRef.current["KHD_BRDCD"] = brandCode;
        // }
        const paramdata = {
            "type": listoptionRef.current,
            "layout_type": baseref.current.ListType(),           
            "controller": formid,
            "data": data,
            "detail": detail,
            "images": imageRef.current,
            "files": fileRef.current,
            "colinfo": savecolumninfo,
            "code": edittingcode,
            "noconfirm": nocheck
        }

        storeRowData();
        return { paramdata: paramdata, newfiles: newfiles };
    }

    function SaveEntry(finallycallback, paramdata, newfiles) {
        fnc.current.postaxios(formstatus === "ENTRY FORM" ? "rawm/UpdateEntry" : "rawm/InsertEntry", paramdata,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.modify(false);
                        let code = data.request;
                        if (formstatus !== "ENTRY FORM") {
                            let pkey = primarykey();
                            if(pkey !== "")  entrydataRef.current[pkey] = data.request;
                            setedittingcode(data.request);
                            dispatch(changestatus("ENTRY FORM"));
                        }
                        if (newfiles.length !== 0) {        //v1.4
                            //新規ファイルアップロード
                            cfFileUpload("forms", code, newfiles, fnc, () => LoadData(code));
                        } else {
                            fnc.current.success();
                            if (formstatus === "ENTRY FORM") {
                                data.data['rowid'] = Getrowid();    //更新行キー
                                finallycallback(data.data);
                            }
                            LoadData(code);     //再表示
                        }
                    }
                    else {
                        if (isEnabled(data.confirm)) {
                            //確認メッセージ
                            var msgs = ["内容を確認しそのまま登録する場合はOK,修正する場合はCancelを選択してください","　"];
                            for (let i = 0; i < data.warning.length; i++) {
                                msgs.push("・" + data.warning[i].message);
                            }
                            fnc.current.confmsg(msgs, () => Save(finallycallback, true));
                        } else {
                            let msg = data.warning.length + "件の制約違反により登録できませんでした。";
                            fnc.current.showwarndescription(msg, data.warning);
                        }
                    }
                    fnc.current.wait(false);
                },
                errmsg: "登録に失敗しました"
            }
        )
    }
    function Delete(finallycallback) {
        const param = {
            type: listoptionRef.current,
            rowdata: [{ "rowid": edittingcode }],
            controller: controller
        }
        fnc.current.postaxios("rawm/Delete", param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.success();
                        finallycallback(edittingcode, primarykeys);
                    }
                    else {
                        fnc.current.warnmsg(["このデータは削除できません", data.warning[0].message]);
                    }
                    fnc.current.wait(false);
               },
                errmsg: "削除に失敗しました"
            }
        )
    }
    function Getrowid() {
        let data = getglobaldata("entryrowdata");
        if (isEmpty(data)) return "";
        return data.rowid;
    }
    function isApproved(data) {
        if (listoptionRef.current !== "0") return false;    //素材のみ承認済み判定　暫定
        var id = listoptionRef.current === "0" ? "KHD_REQ" : "FRH_REQ";
        return data[id].indexOf("承認済み") !== -1;
    }
    //編集ロック
    function changecelllock(columnids, locked) {
        const updateColumns = (fields) => {
            if (isEmpty(fields) || !Array.isArray(columnids)) return fields;

            let changed = false;
            const newfields = DeepCopy(fields);

            newfields.forEach(field => {
                if (columnids.includes(field.columnid) && field.locked !== locked) {
                    field.locked = locked;
                    changed = true;
                }
            });

            return changed ? newfields : fields;
        };

        settextfieldsall(prev => updateColumns(prev));
        settextfields(prev => updateColumns(prev));
    }

    function LoadData(code) {
        if (code === "") return;
        fnc.current.postaxios('rawm/GetData', { "code": code, "colinfo": columninfo, "controller": controller, type: listoptionRef.current },
            {
                onSuccess: function (data) {
                    try {
                        if (code !== "") {
                            //ViewからのMyField値を引継ぎ
                            let row = getglobaldata("entryrowdata");
                            const beforeData = entrydataRef.current;
                            fnc.current.margeMaster(data.master);
                            entrydataRef.current = keepListOptionValue(data.data, beforeData);
                            //行データ
                            for (let i = 0; i < gridlist.length; i++) {
                                const detaildata = data.detail[gridlist[i].type];
                                if (!isEmpty(detaildata)) {
                                    SetGridData(gridlist[i], detaildata);
                                    if (existTotal(gridlist[i].id)) {
                                        //合計セット
                                        SetTotalData(gridlist[i].id, detaildata, true);
                                    }
                                }
                            }
                            gridlist.filter(e => e.id === G_id.PL).forEach(function (l) {
                                //PL行データ
                                SetGridData(l, fnc.current.PLRowData(data.data, l.type, columninfo));
                            });

                            if (listoptionRef.current === "0") {    //原材料
                                setKikakueColumnName(data.data["KHD_HACHUTANI"]);
                                showpanel('0', '101', (data.data['KHD_SHOKUFLG'] === '1'));
                                let newmenu = entryNavMenu().filter(e => e.menuid !== 'print2' && e.menuid !== 'print3' && e.menuid !== 'print4');
                                newmenu.push({ status: "ENTRY FORM", menuid: "sep" });
                                newmenu.push({ status: "ENTRY FORM", menuid: "datacall1", icon: "open_in_new", label: "素材出荷依頼入力" });
                                newmenu.push({ status: "ENTRY FORM", menuid: "datacall2", icon: "open_in_new", label: "素材出荷依頼一括作成" });
                                baseref.current?.ChangeNavmenu(newmenu);

                                //承認後ロック
                                 var ids = ["KHD_HACHUBI", "KHD_HACHUKIND", "KHD_HACHUMOTOCD", "KHD_BRDCD", "KHD_HACHUSAKICD","KHD_DROPSHIPFLG",
                                            "KHD_HACHUTANTOCD", "KHD_INTANTOCD", "KHD_KIKAKU", "KHD_KIKAKUE", "KHD_LEADTIME", "KHD_ZAISIKYUTANKA", 
                                            "KHD_SHOKUNM", "KHD_SHOKUKANA", "KHD_SHOKUCOUNTYCD", "KHD_SHOKUBUMONMEI", "KHD_HINBAN",
                                            "KHD_SHOKUYUBIN", "KHD_SHOKUSTATEMEI", "KHD_SHOKUCITYMEI", "KHD_SHOKUTOWNMEI", "KHD_SHOKUADDR",
                                            "KHD_SHOKUBUILMEI", "KHD_SHOKUTEL", "KHD_SHOKUFAX", "KHD_SHOKUTANTOMEI"];
                                changecelllock(ids, isApproved(data.data));

                            } else {
                                showpanel('0', '103', (data.data['FRH_SHOKUFLG'] === '1'));
                                //出荷先区分により参照マスタ変更
                                setSyukasakiMaster(data.data["FRH_SYUKASAKIKBN"]);
                                if (listoptionRef.current === "1")
                                    baseref.current?.ChangeNavmenu(entryNavMenu().filter(e => e.menuid !== 'print1' && e.menuid !== 'print3' && e.menuid !== 'print4'));
                                else
                                    baseref.current?.ChangeNavmenu(entryNavMenu().filter(e => e.menuid !== 'print1' && e.menuid !== 'print2'));

                                //承認後ロック
                                 var ids = ["FRH_HACHUBI", "FRH_SYUKAKIBOBI", "FRH_HACHUKIND", "FRH_HACHUMOTO", "FRH_BRDCD","FRH_HACHUSAKICD",
                                            "FRH_TANTOCD", "FRH_INTANTOCD","FRH_SYUKASAKIKBN", "FRH_SYUKASAKICD","FRH_SHOKUNM", "FRH_SHOKUKANA", "FRH_SHOKUCOUNTYCD", "FRH_SHOKUBUMONMEI",
                                            "FRH_SHOKUYUBIN", "FRH_SHOKUSTATEMEI", "FRH_SHOKUCITYMEI", "FRH_SHOKUTOWNMEI", "FRH_SHOKUADDR", "FRH_SHOKUBUILMEI", "FRH_SHOKUTEL",
                                            "FRH_SHOKUFAX", "FRH_SHOKUTANTOMEI", "FRH_SYUKASAKINM", "FRH_SYUKASAKIKANA", "FRH_SYUKASAKICOUNTRYCD", "FRH_SYUKASAKIBUMONMEI", "FRH_SYUKASAKIYUBIN",
                                            "FRH_SYUKASAKISTATEMEI","FRH_SYUKASAKICITYMEI", "FRH_SYUKASAKITOWNMEI", "FRH_SYUKASAKIADDR", "FRH_SYUKASAKIBUILMEI",
                                     "FRH_SYUKASAKITEL", "FRH_SYUKASAKIFAX", "FRH_SYUKASAKITANTOMEI" ];
                                changecelllock(ids, isApproved(data.data));
                               
                            }

                            fileRef.current = data.files;
                            imageRef.current = data.images;
                            dispatch(setimagelist(data.images));
                            rerender();
                            dispatch(changestatus("ENTRY FORM"));
                        }
                        fnc.current.wait(false);
                   } catch (error) {
                        console.log(error);
                        fnc.current.wait(false);
                   }
                },
                onError: function (data) {
                    let msg = "処理に失敗しました";
                    if (!isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    fnc.current.warnmsg(msg);
                    dispatch(changestatus("VIEW"));
                    fnc.current.wait(false);
                }
            }
        )
    }
    function SetPLData() {
        gridlist.filter(e => e.id === G_id.PL).forEach(function (l) {
            let column = columninfo.find(e => e.type === l.type);
            if (!isEmpty(column)) {
                entrydataRef.current[column.columnid] = fnc.current.PLTextData(GridData(l), column.columnid);
            }
        });
    }
    //入力フィールドクリア
    function clearform(newform) {
        entrydataRef.current = null;
        imageRef.current = null;
        fileRef.current = null;
        scrollRef.current = null;
        for (let i = 0; i < gridlist.length; i++) {
            SetGridData(gridlist[i], null);
        }

        showpanel('0', '101', false);  //諸口非表示
        dispatch(setimagelist([]));
        fnc.current.modify(false);

        if (isEnabled(newform)) {
            //SQL初期値セット
            var initdata = initializedata(ShowTextField(), staff);
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: ShowTextField(), data: initdata },
            {
                onSuccess: function (data) {
                    entrydataRef.current = data.data;
                    if (listoptionRef.current === "0") {
                        setKikakueColumnName(DicVal(entrydataRef.current, "KHD_HACHUTANI", ''));
                    }
                    rerender();
                    fnc.current.wait(false);
                },
            }, 'wait'
            )
        }
        //有効な入力項目
        function ShowTextField() {
            if (isEmpty(textfieldsall)) return [];

            return textfieldsall.filter(col => {
                if (isEmpty(col)) return false;
                if (col.logpid === G_id.BASE) {
                    return panel.some(p => p.id === G_id.BASE && p.type === col.type && !panelhidden(p));
                }
                return false;
            });
        }

    }

    function ChangeRowValue(params, panel) {
        if (listoptionRef.current === "0") {
            if (params.column.colDef.colinfo.datatype !== CELLTYPE.NUM) {
                storeRowData(panel);
                if (params.column.colId === "KHDM_COLORKEY") {
                    GetZaiColorInfo(params.newValue, params.data.rowid);
                }
                return;
            }
            var rowdata = GridData(panel).find(e => e.rowid === params.data.rowid);
            if (params.column.colId === "KHDM_TANSU" && !isEmpty(rowdata)) {
                //M=反数×規格長
                let value = NumConv(params.newValue) * NumConv(entrydataRef.current["KHD_KIKAKUE"]);
                rowdata["KHDM_MATERSU"] = GetDesitRound(value, 1, 2);   //四捨五入
            }
            if (params.column.colId === "KHDM_MATERSU" && !isEmpty(rowdata)) {
                //反数=M÷規格長
                let value = NumConv(params.newValue) / NumConv(entrydataRef.current["KHD_KIKAKUE"]);
                rowdata["KHDM_TANSU"] = GetDesitRound(value, 2, 1);      //切り上げ
            }
            //if (entrydataRef.current["KHD_TSUKATANI"] !== "JPY" && params.column.colId === "KHDM_TANKA" && !isEmpty(rowdata)) {
            if (isFX() && params.column.colId === "KHDM_TANKA" && !isEmpty(rowdata)) {
                //外貨単価を取得
                rowdata["KHDM_TANKAF"] = ExchangePrice(params.newValue, 1);
            }
            //if (entrydataRef.current["KHD_TSUKATANI"] !== "JPY" && params.column.colId === "KHDM_TANKAF" && !isEmpty(rowdata)) {
            if (isFX() && params.column.colId === "KHDM_TANKAF" && !isEmpty(rowdata)) {
                //円単価を取得
                rowdata["KHDM_TANKA"] = ExchangePrice(params.newValue, 0);
            }
            RowDataChanged(panel);
        } else {
            if (params.column.colDef.colinfo.datatype !== CELLTYPE.NUM) {
                storeRowData(panel);
                if (params.column.colId === "FRHM_ZAIHINBAN") {
                    GetFuzokuInfo(params.newValue, params.data.rowid);
                    return;
                }
                if (params.column.colId === "FRHM_ZAICOLORCD") {
                    GetFuzokuColInfo(params.newValue, params.data.rowid);
                    return;
                }
                return;
            }
            var rowdata = GridData(panel).find(e => e.rowid === params.data.rowid);
            //if (entrydataRef.current["FRH_TSUKATANI"] !== "JPY" && params.column.colId === "FRHM_TANKA" && !isEmpty(rowdata)) {
            if (isFX() && params.column.colId === "FRHM_TANKA" && !isEmpty(rowdata)) {
                //外貨単価を取得
                rowdata["FRHM_TANKAF"] = ExchangePrice(params.newValue, 1);
            }
            //if (entrydataRef.current["FRH_TSUKATANI"] !== "JPY" && params.column.colId === "FRHM_TANKAF" && !isEmpty(rowdata)) {
            if (isFX() && params.column.colId === "FRHM_TANKAF" && !isEmpty(rowdata)) {
                //円単価を取得
                rowdata["FRHM_TANKA"] = ExchangePrice(params.newValue, 0);
            }
            // 副資材
            if (listoptionRef.current === "2") {
                // ロス無し数量
                if (params.column.colId === "FRHM_LOSNASHISURYO" && !isEmpty(rowdata)) {
                    rowdata["FRHM_SURYO"] = getSuryo(NumConv(rowdata["FRHM_LOSNASHISURYO"]), NumConv(rowdata["FRHM_LSURYO"]), NumConv(rowdata["FRHM_LOSSRITU"]));
                }
                // ロス数量
                if (params.column.colId === "FRHM_LSURYO" && !isEmpty(rowdata)) {
                    rowdata["FRHM_SURYO"] = getSuryo(NumConv(rowdata["FRHM_LOSNASHISURYO"]), NumConv(rowdata["FRHM_LSURYO"]), NumConv(rowdata["FRHM_LOSSRITU"]));
                }
                // ロス率
                if (params.column.colId === "FRHM_LOSSRITU" && !isEmpty(rowdata)) {
                    rowdata["FRHM_SURYO"] = getSuryo(NumConv(rowdata["FRHM_LOSNASHISURYO"]), NumConv(rowdata["FRHM_LSURYO"]), NumConv(rowdata["FRHM_LOSSRITU"]));
                }
            }
            RowDataChanged(panel);
        }
    }
    // ①ロス数量が入力されている場合
    // 　ロス率の入力有無にかかわらず、
    // 　発注数量 ＝ ロス無し数量 ＋ ロス数量
    // ②ロス数量が未入力かつロス率が入力されている場合
    // 　発注数量 ＝ ロス無し数量 × （1 ＋ ロス率／100）
    // ③ロス数量、ロス率ともに未入力の場合
    // 　登録時、発注数量にはロス無し数量と同一値を自動設定する。
    function getSuryo(losNashiSuryo, lSuryo, lossRitu) {
        // ①
        if (lSuryo !== 0) {
            return losNashiSuryo + lSuryo;
        }
        // ②
        if (lSuryo === 0 && lossRitu !== 0) {
            return losNashiSuryo * (1 + lossRitu / 100);
        }
        // ③
        if (lSuryo === 0 && lossRitu === 0) {
            return losNashiSuryo;
        }
    }
    function RowValueChanged(colid, targets,panel) {
        RowDataChanged(panel);
    }
    //外貨かどうか
    function isFX() {
        var id = listoptionRef.current === '0' ? "KHD_TSUKATANI" : "FRH_TSUKATANI";
        if (isEmpty(entrydataRef.current[id])) return false;
        return entrydataRef.current[id] !== "JPY";
    }
    //Grid Row Data Change
    function RowDataChanged( panel) {
        if (isEmpty(GridApi(panel))) return;
        var data = GridData(panel);
        if (isEmpty(data)) data = [];
        for (let i = 0; i < data.length; i++) {
            if (listoptionRef.current === "0") {
                //金額再計算
                var qty = NumConv(data[i]["KHDM_MATERSU"]);
                if (isFX()) {
                    data[i]["KHDM_HACHUKINGAKUF"] = calcamount(qty, data[i]["KHDM_TANKAF"], 1);
                } else {
                    data[i]["KHDM_TANKAF"] = 0;
                    data[i]["KHDM_FIXTANKAF"] = 0;
                    data[i]["KHDM_HACHUKINGAKUF"] = 0;
                }
                data[i]["KHDM_HACHUKINGAKU"] = calcamount(qty, data[i]["KHDM_TANKA"], 0);
            } else {
                var qty = NumConv(data[i]["FRHM_SURYO"]);
                if (isFX()) {
                    data[i]["FRHM_KINGAKUF"] = calcamount(qty, data[i]["FRHM_TANKAF"], 1);
                } else {
                    data[i]["FRHM_TANKAF"] = 0;
                    data[i]["FRHM_FIXTANKAF"] = 0;
                    data[i]["FRHM_HACHUKINGAKUF"] = 0;
                }
                data[i]["FRHM_KINGAKU"] = calcamount(qty, data[i]["FRHM_TANKA"], 0);
            }
        }
        fnc.current.rerenderGrid(panel);
        if (existTotal(panel)) {
            SetTotalData(panel, data);
        }
    }
    function SetTotalData(id, data) {
        if (id === "1") {
            let total = { qty: 0, amt: 0, curamt: 0 };
            for (let i = 0; i < data.length; i++) {
                total.qty += NumConv(data[i]["KHDM_MATERSU"]);
                total.amt += NumConv(data[i]["KHDM_HACHUKINGAKU"]);
                total.curamt += NumConv(data[i]["KHDM_HACHUKINGAKUF"]);
            }
            let rowNode = GridApi("T" + id).getRowNode("TOTAL");
            if (!isEmpty(rowNode)) {
                rowNode.setDataValue('KHD_QTY_T', total.qty);
                rowNode.setDataValue('KHD_AMT_T', total.amt);
                rowNode.setDataValue('KHD_FAMT_T', total.curamt);
            }
        } else {
            let total = { qty: 0, amt: 0, curamt: 0 };
            for (let i = 0; i < data.length; i++) {
                total.qty += NumConv(data[i]["FRHM_SURYO"]);
                total.amt += NumConv(data[i]["FRHM_KINGAKU"]);
                total.curamt += NumConv(data[i]["FRHM_KINGAKUF"]);
            }
            let rowNode = GridApi("T" + id).getRowNode("TOTAL");
            if (!isEmpty(rowNode)) {
                rowNode.setDataValue('FRH_QTY_T', total.qty);
                rowNode.setDataValue('FRH_AMT_T', total.amt);
                rowNode.setDataValue('FRH_FAMT_T', total.curamt);
            }
        }
    }
    //金額計算
    function calcamount(qty, price, mode) {
        var amt = NumConv(qty) * NumConv(price);
        if (mode === 0) {   //円
            return GetRound(amt, 0);
        } else {            //外貨
            return GetDesitRound(amt, 0, 2);
        }
    }
    //外貨→円、円→外貨変換
    function ExchangePrice(price, mode) {
        var rate = NumConv(entrydataRef.current[listoptionRef.current === "0"?"KHD_SHANAIRATE":"FRH_RATE"]);
        if (mode === 0) {   //外貨→円
            return GetRound(rate * price, 1);
        } else {            //円→外貨
            return GetDesitRound(price / rate, 1, 2);
        }
    }
    //外貨から円単価を再計算
    function RecalcExchange() {
        var data = GridData(OptID());
        if (isEmpty(data)) data = [];
        for (let i = 0; i < data.length; i++) {
            //円単価＝外貨×レート
            var price = ExchangePrice(NumConv(data[i][listoptionRef.current === "0" ? "KHDM_TANKAF" : "FRHM_TANKAF"]),0);
            data[i][listoptionRef.current === "0" ? "KHDM_TANKA" : "FRHM_TANKA"] = price;
        }
        RowDataChanged({ id: OptID() });
    }

    //Basic Data Change
    function ValueChanged(id, value, edit) {
        //var current = entrydataRef.current[id];
        //if (current === value) return;
        if (id === "KHD_HACHUTANI") {   //発注単位
            setKikakueColumnName(value);    //規格ラベル変更
        }
        if (edit) {
            if (id === "KHD_HACHUBI" || id === "FRH_HACYUBI") {     //発注日
                //外貨の場合レート取得
                if (entrydataRef.current[listoptionRef.current === "0" ? "KHD_TSUKATANI": "FRH_TSUKATANI"] !== "JPY") {
                    GetRate();
                }
            }
            if (id === "KHD_TSUKATANI" || id === "FRH_TSUKATANI") {   //通貨単位
                if (value !== "JPY") GetRate();
                else setExchangeRateValue(1);
            }
            if (id === "KHD_HACHUSAKICD" || id === "FRH_HACHUSAKICD") {  //発注先
                GetTorihikiInfo();
            }
            if (id === "KHD_HINBAN") {       //素材
                GetZairyoInfo();
            }
            if (id === "FRH_SYUKASAKIKBN") {    //出荷先区分
                setSyukasakiMaster(value);
                entrydataRef.current = {
                    ...(isEmpty(entrydataRef.current) ? {} : entrydataRef.current),
                    FRH_SYUKASAKICD: "",
                    FRH_SYUKASAKICD_cd: "",
                    FRH_SYUKASAKISUBCD: ""
                };
                fnc.current.entryrerender();
            }
            if (id === "FRH_SYUKASAKICD") {     //出荷先
                if (!isEmpty(value)) {
                    GetSyukaInfo(value);
                }
            }
        }
        //外部からの参照がある項目
        let col = columninfo.find(e => e.columnid === id);
        if (!isEmpty(col)) {
            if (col.extriggerref) {
                dispatch(entrytriggercall(id));
            }
        }
    }
    //原材料カラー情報取得
    function GetZaiColorInfo(code, rowid) {
        var data = {};
        var rowdata = GridData(OptID()).find(e => e.rowid === rowid);
        data["torcd"] = entrydataRef.current["KHD_HACHUSAKICD"];
        data["hinban"] = entrydataRef.current["KHD_HINBAN"];
        data["brand"] = entrydataRef.current["KHD_BRDCD"];
        data["color"] = code;
        if (isEmpty(data["torcd"]) || isEmpty(data["hinban"]) || isEmpty(data["brand"]) || isEmpty(code)) {
            rowdata["KHDM_COLORNO"] = "";
            rowdata["KHDM_MEKERCOLORNO"] = "";
            return;
        } else {
            rowdata["KHDM_COLORNO"] = code.split('_')[0];
            rowdata["KHDM_MEKERCOLORNO"] = code.split('_')[1];
        }
        fnc.current.postaxios('RawM/GetZAIColorInfo',
            {
                controller: controller,
                data: data
            },
            {
                onSuccess: function (data) {
                    var rowdata = GridData(OptID()).find(e => e.rowid === rowid);
                    if (data.results !== "OK") {
                        rowdata["KHDM_COLORKEY"] = "";
                        rowdata["KHDM_COLORNO"] = "";
                    }
                    rowdata["KHDM_COLORNM"] = data.rowdata["ZAIC_COLORNM"];
                    //if (entrydataRef.current["KHD_TSUKATANI"] === "JPY") {
                    if (!isFX()) {
                        rowdata["KHDM_TANKA"] = NumConv(data.rowdata["KHDM_TANKA"]);
                    } else {
                        rowdata["KHDM_TANKAF"] = NumConv(data.rowdata["KHDM_TANKAF"]);
                        //円単価を取得
                        rowdata["KHDM_TANKA"] = ExchangePrice(NumConv(data.rowdata["KHDM_TANKAF"]), 0);
                    }
                    RowDataChanged(OptID());
                    fnc.current.wait(false);
                },
            },
            'wait'
        )
    }
    //原材料情報取得
    function GetZairyoInfo() {
        var data = {};
        data["torcd"] = entrydataRef.current["KHD_HACHUSAKICD"];
        data["hinban"] = entrydataRef.current["KHD_HINBAN"];
        data["brand"] = entrydataRef.current["KHD_BRDCD"];
        if (isEmpty(data["torcd"]) || isEmpty(data["hinban"]) || isEmpty(data["brand"])) {
            data["KHD_HINBAN"] = ""
            data["KHD_MAKERHINBAN"] = ""
            data["KHD_SEASONCD"] = ""
            data["KHD_COUNTRY"] = ""
            data["KHD_KIKAKU"] = ""
            data["KHD_KIKAKUE"] = ""
            data["KHD_LEADTIME"] = ""
            data["KHD_HACHUTANI"] = ""
            data["ZAI_LOT"] = ""
            data["ZAI_MINIAMU"] = ""
            entrydataRef.current = { ...entrydataRef.current, ...data };
            fnc.current.entryrerender();
            return;
        }
        fnc.current.postaxios('RawM/GetZAIInfo',
            {
                controller: controller,
                data: data
            },
            {
                onSuccess: function (data) {
                    if (data.results === "NG") {
                        data.rowdata = {};
                        data.rowdata["KHD_HINBAN"] = "";
                        data.rowdata["KHD_MAKERHINBAN"] = ""
                        data.rowdata["KHD_SEASONCD"] = ""
                        data.rowdata["KHD_COUNTRY"] = ""
                        data.rowdata["KHD_KIKAKU"] = ""
                        data.rowdata["KHD_KIKAKUE"] = ""
                        data.rowdata["KHD_LEADTIME"] = ""
                        data.rowdata["KHD_HACHUTANI"] = ""
                        data.rowdata["ZAI_LOT"] = ""
                        data.rowdata["ZAI_MINIAMU"] = ""
                    }
                    entrydataRef.current = { ...entrydataRef.current, ...data.rowdata };
                    fnc.current.entryrerender();
                    fnc.current.wait(false);
                },
            },
            'wait'
        )
   }

    //仕入先情報取得
    function GetTorihikiInfo() {
        var data = {};
        data["torcd"] = entrydataRef.current[listoptionRef.current === '0' ? "KHD_HACHUSAKICD" : "FRH_HACHUSAKICD"];
        if (listoptionRef.current === '0') {
            data["hinban"] = entrydataRef.current["KHD_HINBAN"];
        }
        data["date"] = entrydataRef.current[listoptionRef.current === '0' ? "KHD_HACHUBI":"FRH_HACHUBI"];
        data["brand"] = entrydataRef.current[listoptionRef.current === '0' ? "KHD_BRDCD":"FRH_BRDCD"];
        if (isEmpty(data["torcd"])) {
            if (listoptionRef.current === '0') {
                entrydataRef.current["KHD_KAIGAIKBN"] = "0"
                entrydataRef.current["KHD_TSUKATANI"] = ""
                entrydataRef.current["KHD_SIIRESAKIBUMONNM"] = ""
                entrydataRef.current["KHD_SIIRESAKITANTONM"] = ""
            } else {
                entrydataRef.current["FRH_KAIGAIKBN"] = "0"
                entrydataRef.current["FRH_TSUKATANI"] = ""
            }
            return;
        }
        fnc.current.postaxios('RawM/GetTORInfo',
            {
                type: listoptionRef.current,
                controller: controller,
                data: data
            },
            {
                onSuccess: function (data) {
                    entrydataRef.current = { ...entrydataRef.current, ...data.rowdata };
                    fnc.current.entryrerender();
                    if (listoptionRef.current === '0') {
                        showpanel('0', '101', (data.rowdata['KHD_SHOKUFLG'] === '1'));  //諸口によりセクション表示
                        entrydataRef.current["KHD_SHOKUFLG"] = data.rowdata["KHD_SHOKUFLG"];
                        //if (data.rowdata["KHD_TSUKATANI"] === "JPY") {
                        if (!isFX()) {
                            RowDataChanged({ id: OptID() });
                        } else {
                            //単価再計算
                            RecalcExchange();
                        }
                    } else {
                        showpanel('0', '103', (data.rowdata['FRH_SHOKUFLG'] === '1'));  //諸口によりセクション表示
                        entrydataRef.current["FRH_SHOKUFLG"] = data.rowdata["FRH_SHOKUFLG"];
                        //if (data.rowdata["FRH_TSUKATANI"] === "JPY") {
                        if (!isFX()) {
                            RowDataChanged({ id: OptID() });
                        } else {
                            //単価再計算
                            RecalcExchange();
                        }
                    }
                    fnc.current.wait(false);
                },
            },
            'wait'
        )
    }
    //出荷先情報取得
    function GetSyukaInfo(value) {
        fnc.current.postaxios('RawM/GetSyukaInfo',
            {
                type: entrydataRef.current["FRH_SYUKASAKIKBN"],
                controller: controller,
                code: value
            },
            {
                onSuccess: function (data) {
                    entrydataRef.current = { ...entrydataRef.current, ...data.rowdata };
                    // 工場出荷先では、表示用コードとは別に親取引先コードと
                    // 工場サブコードを保存・参照整合性チェック用に保持する。
                    if (entrydataRef.current["FRH_SYUKASAKIKBN"] === "2") {
                        entrydataRef.current["FRH_SYUKASAKICD_cd"] =
                            DicVal(data.rowdata, "FRH_SYUKASAKICD_cd", "");
                        entrydataRef.current["FRH_SYUKASAKISUBCD"] =
                            DicVal(data.rowdata, "FRH_SYUKASAKISUBCD", value);
                    }
                    fnc.current.entryrerender();
                    fnc.current.wait(false);
                },
            },
            'wait'
        )
    }
    function setExchangeRateValue(value) {
        const rateColumnId = listoptionRef.current === "0" ? "KHD_SHANAIRATE" : "FRH_RATE";
        entrydataRef.current = {
            ...(isEmpty(entrydataRef.current) ? {} : entrydataRef.current),
            [rateColumnId]: value
        };
    }
    function GetRate() {
        var data = {};
        data["unit"] = entrydataRef.current[listoptionRef.current === '0' ? "KHD_TSUKATANI" :"FRH_TSUKATANI"];
        data["date"] = entrydataRef.current[listoptionRef.current === '0' ? "KHD_HACHUBI" :"FRH_HACHUBI"];
        fnc.current.postaxios('TSICom/GetRate',
            {
                controller: controller,
                data: data
            },
            {
                onSuccess: function (data) {
                    setExchangeRateValue(data.request);
                    fnc.current.entryrerender();
                    //単価再計算
                    RecalcExchange();
                    fnc.current.wait(false);
                },
            },
            'wait'
        )
    }

    //附属情報取得
    function GetFuzokuInfo(code, rowid) {
        const FZKMEICOL = ["FRHM_ZAISIIRESAKICD", "FRHM_ZAICOLORCD", "FRHM_ZAICOLORNM", "FRHMS_SEICOLORCD", "FRHM_ZAISIZECD",
            "FRHM_MATERSUYOTEI", "FRHM_SURYO", "FRHM_TANI", "FRHM_TANKAF", "FRHM_TANKA", "FRHM_FIXTANKAF",
            "FRHM_FIXTANKA", "FRHM_KINGAKUF", "FRHM_IOTAXKBN", "FRHM_KINGAKU", "FRHM_TANKASYNFLG1", "FRHM_NOUKI", "FRHM_BIKO"];
        var data = {};
        var rowdata = GridData(OptID()).find(e => e.rowid === rowid);
        data["kubun"] = listoptionRef.current;
        data["ssdno"] = rowdata["FRHM_SSDNO"];
        data["torcd"] = entrydataRef.current["FRH_HACHUSAKICD"];
        data["brand"] = entrydataRef.current["FRH_BRDCD"];
        data["hinban"] = code;
        if (isEmpty(data["hinban"])) {
            if (rowdata) {
                FZKMEICOL.forEach(col => {rowdata[col] = ""; });
            }
            return;
        }
        if (isEmpty(data["torcd"]) || isEmpty(data["hinban"]) || isEmpty(data["brand"])) {
            return;
        }
        fnc.current.postaxios('RawM/GetFuzokuInfo',
            {
                controller: controller,
                data: data
            },
            {
                onSuccess: function (data) {
                    var rowdata = GridData(OptID()).find(e => e.rowid === rowid);
                    if (data.results === "OK") {
                        rowdata["FRHM_ZAISIIRESAKICD"] = entrydataRef.current["FRH_HACHUSAKICD"];
                        rowdata["FRHM_ZAISIIRESAKICD_cd"] = entrydataRef.current["FRH_HACHUSAKICD_cd"];
                        rowdata["FRHM_ZAISIIRESAKICD_nm"] = entrydataRef.current["FRH_HACHUSAKICD_nm"];
                    } else {
                        rowdata["FRHM_ZAIHINBAN"] = "";
                        rowdata["FRHM_ZAISIIRESAKICD"] = "";
                        rowdata["FRHM_ZAISIIRESAKICD_cd"] = "";
                        rowdata["FRHM_ZAISIIRESAKICD_nm"] = "";
                    }
                    rowdata["FRHM_ZAISIZECD"] = data.rowdata["FRHM_ZAISIZECD"];
                    rowdata["FRHM_IOTAXKBN"] = data.rowdata["FRHM_IOTAXKBN"];
                    if (listoptionRef.current === '1') {    //附属
                        rowdata["FRHM_ZAICOLORCD"] = "";
                        rowdata["FRHM_ZAICOLORNM"] = "";
                        rowdata["FRHMS_SEICOLORCD"] = "";
                        rowdata["FRHM_TANI"] = "";
                        rowdata["FRHM_TANKAF"] = "";
                        rowdata["FRHM_TANKA"] = "";
                        rowdata["FRHM_FIXTANKAF"] = "";
                        rowdata["FRHM_FIXTANKA"] = "";
                        rowdata["FRHM_KINGAKUF"] = "";
                        rowdata["FRHM_KINGAKU"] = "";
                        rowdata["FRHM_TANKASYNFLG1"] = "";
                        fnc.current.rerenderGrid(OptID());
                    } else {                                //副資材
                        rowdata["FRHM_SURYO"] = NumConv(data.rowdata["QTY"]);
                        if (!isFX()) {
                        //if (entrydataRef.current["FRH_TSUKATANI"] === "JPY") {
                            rowdata["FRHM_TANKA"] = NumConv(data.rowdata["TANKA"]);
                            rowdata["FRHM_FIXTANKA"] = NumConv(data.rowdata["TANKA"]);
                        } else {
                            rowdata["FRHM_TANKAF"] = NumConv(data.rowdata["TANKAF"]);
                            rowdata["FRHM_FIXTANKAF"] = NumConv(data.rowdata["TANKAF"]);
                            //円単価を取得
                            rowdata["FRHM_TANKA"] = ExchangePrice(NumConv(data.rowdata["TANKAF"]), 0);
                            rowdata["FRHM_FIXTANKA"] = rowdata["FRHM_TANKA"];
                        }
                        RowDataChanged(OptID());
                    }
                    fnc.current.wait(false);
                },
            },
            'wait'
        )
    }
    //附属カラー情報取得
    function GetFuzokuColInfo(code, rowid) {
        var rowdata = GridData(OptID()).find(e => e.rowid === rowid);
        var data = {};
        data["torcd"] = entrydataRef.current["FRH_HACHUSAKICD"];
        data["brand"] = entrydataRef.current["FRH_BRDCD"];
        data["hinban"] = rowdata["FRHM_ZAIHINBAN"];
        data["color"] = code;
        if (isEmpty(data["hinban"])) {
            rowdata["FRHM_ZAICOLORCD"] = "";
            rowdata["FRHM_ZAICOLORNM"] = "";
            rowdata["FRHMS_SEICOLORCD"] = "";
            return;
        }
        if (isEmpty(data["torcd"]) || isEmpty(data["hinban"]) || isEmpty(data["brand"])) {
            return;
        }
        fnc.current.postaxios('RawM/GetFuzokuColInfo',
            {
                controller: controller,
                data: data
            },
            {
                onSuccess: function (data) {
                    var rowdata = GridData(OptID()).find(e => e.rowid === rowid);
                    if (data.results !== "OK") {
                        rowdata["FRHM_ZAICOLORCD"] = "";
                    }
                    rowdata["FRHM_ZAICOLORNM"] = data.rowdata["FZKC_FCOLORNM"];
                    //if (entrydataRef.current["FRH_TSUKATANI"] === "JPY") {
                    if (!isFX()) {
                        rowdata["FRHM_TANKA"] = NumConv(data.rowdata["FZKC_TANKA"]);
                    } else {
                        rowdata["FRHM_TANKAF"] = NumConv(data.rowdata["FZKC_TANKAF"]);
                        //円単価を取得
                        rowdata["FRHM_TANKA"] = ExchangePrice(NumConv(data.rowdata["FZKC_TANKAF"]), 0);
                    }
                    RowDataChanged(OptID());
                    fnc.current.wait(false);
                },
            },
            'wait'
        )
    }

    //基本項目設定
    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }
    //レイアウト復元
    function RestoreLayout(panels, fields) {
        //パネルの並び
        RestorePanel(panels);
        //基本情報
        RestoreBase(fields)
    }
    function RestorePanel(panel) {
        let paneldata = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(paneldata)) return;
        if (panel.length !== paneldata.length) return;
        for (let i = 0; i < paneldata.length; i++) {
            let item = panel.find(e => e.id === paneldata[i].id && e.type === paneldata[i].type);
            if (isEmpty(item)) return;
            paneldata[i].name = item.name;
            paneldata[i].name2 = item.name2;
            paneldata[i].abbr = item.abbr;
        }
        setpanel(paneldata);
    }
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }
    //レイアウト保持
    function LayoutSaveStorage() {
        //列情報保存
        for (let i = 0; i < gridlist.length; i++) {
            AGRef.current.SaveColState(fnc.current.statusKey(gridlist[i].id, gridlist[i].type, formid), EmptyPanel(gridlist[i].id) ? null : GridColApi({id:gridlist[i].id, type:gridlist[i].type}));
        }
        //基本情報保存
        Savestorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid), textfields);
        //パネルの表示/非表示および並び
        Savestorage(corpkey, account, formid + "panel", panel);
    }

    //レイアウト登録
    function SaveLayout(layoutid) {
        let setbase = false;
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            if (panel[p].id === G_id.BASE) {
                if (setbase) break;
                let fds = textfields.filter(x => !x.hide);
                for (let f = 0; f < fds.length; f++) {
                    coldef.push({
                        headerName: fds[f].columnnm, table: fds[f].table, field: fds[f].columnid, width: fds[f].width,
                        type: fds[f].type
                    });
                }
                setbase = true;
            } else {
                cols = AGRef.current.GetshownColDef(GridColApi({ id: panel[p].id })); 
            }
            for (let i = 0; i < cols.length; i++) {
                let col = DeepCopy(cols[i]);
                col.type = tabletype(panel[p].id);
                coldef.push(col);
            }
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
               },
            }
        )
    }
    //レイアウト削除
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== maininitlayout)
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト呼び出し
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    //列情報初期化
                    for (let i = 0; i < gridlist.length; i++) {
                        var type = gridlist[i].type;
                        var coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                        if (coldef.length === 0) continue;
                        SetGridColDef({ id: gridlist[i].id, type: gridlist[i].type }, coldef);
                    }
                    setpanel(data.panels);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    setcolumns(data.columns);
                    fnc.current.wait(false);
                },
            }
        )
    }

    //リスト編集セル制御
    function ListlockCell(params, edit, status, tabvalue) {
        if (status === "INSERT") {
            //自テーブル以外編集不可
            if (tabvalue !== params.colDef.colinfo.type) return false;
        }
        return edit;
    }
    //明細編集セル制御
    function RowlockCell(params, edit, status, tabvalue) {
        const header = isEmpty(entrydataRef.current) ? null : entrydataRef.current;
        const currencyColumnId = listoptionRef.current === "0" ? "KHD_TSUKATANI" : "FRH_TSUKATANI";
        const currency = isEmpty(header) ? "" : String(DicVal(header, currencyColumnId, "") ?? "").trim();
        if (currency === "") return edit;
        if (currency === "JPY") {
            if (params.colDef.colId === "KHDM_TANKAF" || params.colDef.colId === "KHDM_FIXTANKAF" ||
                params.colDef.colId === "FRHM_TANKAF" || params.colDef.colId === "FRHM_FIXTANKAF") {
                return false;
            }
        } else {
            if (params.colDef.colId === "KHDM_TANKAF" || params.colDef.colId === "KHDM_FIXTANKAF" ||
                params.colDef.colId === "FRHM_TANKAF" || params.colDef.colId === "FRHM_FIXTANKAF") {
                return true;
            }
        }
        //承認済みの場合単価項目以外編集不可
        if (isApproved(entrydataRef.current) && params.colDef.colId.indexOf("TANKA") === -1) return false;
        return edit;
    }

    //idに対する合計行が存在するか
    function existTotal(id) {
        return gridlist.some(e => e.id === "T" + id);
    }

    //idに対する種別を取得
    function tabletype(id) {
        if (id.substr(0, 1) === "T") {  //Total
            if (isEmpty(columninfo)) return "";
            let col = columninfo.find(e => e.logpid === id);
            if (isEmpty(col)) return '';
            return col.type;
        } else {
            let pnl = panel.find(e => e.id === id);
            if (isEmpty(pnl)) return '';
            return pnl.type;
        }
    }

    //File Upload 再表示
    function fileuploaded(data) {
        let duplicate = false;
        if (formstatus === 'NEW FORM' || formstatus === 'COPY FORM') {  //v1.4
            if (cfMargeUploadFiles(imageRef, data.images)) duplicate = true;
            if (cfMargeUploadFiles(fileRef, data.files)) duplicate = true;
        } else {
            imageRef.current = data.images;
            fileRef.current = data.files;
        }
        dispatch(setimagelist(imageRef.current));
        rerender();
        //v1.4
        if (duplicate) fnc.current.warnmsg("同名のファイルが存在しました。差し替える場合は元のファイルを削除してからアップロードしてください");
    }


    //panel入れ替え
    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        setpanel(arrayMove(panel, oldidx, newidx));
    };

    //パネルセレクタ
    function panelnavwidth() {
        return windowDimensions.width - 280;
    }
    const SortablePanelItem = SortableElement(({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip
                label={pnl.name}
                title={pnl.name}
                size="small"
                onClick={() => Jump(pnl.id, pnl.type)}
            />
        </ListItem>
    ));
    const SortablePanelSelector = SortableContainer(({ items }) => {
        var newitem = [];
        for (let i = 0; i < items.length; i++) {
            if (!panelhidden(items[i])) newitem.push(items[i]);
        }
        return (
            <ul style={{ display: 'flex' }}  >
                {newitem.map((value, index) => (
                    <SortablePanelItem key={`item-${index}`} index={index} pnl={value} />
                ))}
            </ul>
        );
    });

    function Contents(props) {
        if (props.panel.id === G_id.BASE) {
            const baseid = "basepanel" + props.panel.type;
            return (
                <div id={baseid} >
                    <EntryBase
                        fnc={fnc}
                        textfields={textfields}
                        settextfields={settextfields}
                        panel={props.panel}
                        ValueChanged={ValueChanged}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock}
                    />
                </div>
            );
        }
        if (props.panel.id === G_id.IMAGE) {
            return (
                <EntryImages
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={imageRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.grid) {
            if (props.panel.id !== G_id.PL) {
                return (
                    <React.Fragment>
                        <EntryGridAr
                            id={ fnc.current.GridID(props.panel)}
                            entrydataRef={entrydataRef}
                            dataRef={griddataRefs.current[fnc.current.gridindex(props.panel)]}
                            columnRef={gridcolRefs.current[fnc.current.gridindex(props.panel)]}
                            columninfo={columninfo}
                            columns={columns}
                            fnc={fnc}
                            onGridReady={onGridReady}
                            onFirstDataRendered={onFirstDataRendered}
                            ValueChanged={(e)=>ChangeRowValue(e, props.panel)}
                            RowValueChanged={(colid, rows) => RowValueChanged(colid,rows,props.panel)}
                            RemoveRow={()=>RowDataChanged(props.panel)}
                            formid={formid}
                            panel={props.panel}
                            lockcell={RowlockCell}
                        />
                     { !existTotal(props.panel.id) ? null :
                        <EntryGridAr
                                id={fnc.current.GridID("T" + props.panel.id)}
                                entrydataRef={entrydataRef}
                                dataRef={griddataRefs.current[fnc.current.gridindex("T" + props.panel.id)]}
                                columnRef={gridcolRefs.current[fnc.current.gridindex("T" + props.panel.id)]}
                                columninfo={columninfo}
                                columns={columns}
                                fnc={fnc}
                                onGridReady={onGridReady}
                                onFirstDataRendered={onFirstDataRendered}
                                formid={formid}
                                panel={props.panel}
                                total={true}
                                totaltype={tabletype("T" + props.panel.id) }
                        />
                    }
                    </React.Fragment>
               );
            } else {
                return (
                    <EntryGridAr
                        id={fnc.current.GridID(props.panel)}
                        entrydataRef={entrydataRef}
                        dataRef={griddataRefs.current[fnc.current.gridindex(props.panel)]}
                        columnRef={gridcolRefs.current[fnc.current.gridindex(props.panel)]}
                        columninfo={columninfo}
                        columns={columns}
                        fnc={fnc}
                        onFirstDataRendered={onFirstDataRendered}
                        formid={formid}
                        ValueChanged={() => storeRowData(props.panel)}
                        panel={props.panel}
                    />
                );
            }
        }
        if (props.panel.id === G_id.FILE) {
            return (
                <EntryFiles
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={fileRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.id === G_id.NB) {
            if (isEmpty(columninfo)) return null;
            let coldef = columninfo.find(e => e.type === props.panel.type);
            return (
                <EntryRemarks
                    id={"remarkspanel" + props.panel.type}
                    def={coldef}
                    dataRef={entrydataRef}
                    fnc={fnc}
                    ValueChanged={ValueChanged}
                />
            )
        }
        return null;

    }
    function EmptyPanel(id, type) {
        try {
            if (!panel.some(e => e.id === id)) return true; //パネル定義なし
            if (!isEmpty(type)) {
                if (!panel.some(e => e.id === id && e.type === type)) return true; //パネル定義なし
            }
            if (id === G_id.BASE) return isEmpty(textfields.find(e => e.type === type));
            let tbltype = tabletype(id);
            return !columns.some(e => e.type === tbltype);
        } catch { }
        return false;
    }
    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if (p.id === G_id.IMAGE) {
            if (isEmpty(imageRef.current)) return true;
            if (imageRef.current.length === 0) return true;
            return p.hide;
        }
        if (p.id === G_id.FILE) {
            if (isEmpty(fileRef.current)) return true;
            if (fileRef.current.length === 0) return true;
            return p.hide;
        }
        switch (listoptionRef.current) {
            case "0":
                if (!SZIType.includes(p.type)) return true;
                break;
            case "1":
                if (!FZKType.includes(p.type)) return true;
                break;
            case "2":
                if (!FZIType.includes(p.type)) return true;
                break;
        }
        if (EmptyPanel(p.id, p.type)) return true;
        return p.hide;
    }
    function EntryForm() {
        return (
            <div style={{ padding: '5px 15px', paddingBottom: '300px', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }} ref={EntrybodyRef} onDragEnter={onDragEnter}>
                {panel.map((p,i) => {
                   return (
                        <Box
                           display={panelhidden(p) ? "none" : "flex"}
                           justifyContent="space-around"
                           alignItems="center"
                           padding="5px"
                            >
                            <Paper
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    padding: 10
                                }}
                           >
                               <div style={{ position: 'relative', marginBottom: 5 }}>
                                   {p.name} - <span style={{ fontStyle: 'oblique' }}>{p.name2}</span>
                                   {p.id !== '0' || layoutlock ? null :
                                       <div style={{ position: 'absolute', right: 40, top: -3 }} title="項目設定">
                                           <IconButton size="small" onClick={()=>SetBaseField(p.type)}  >
                                               <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                           </IconButton>
                                       </div>
                                   }
                                   {layoutlock || sectionclose ? null :
                                       <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                           <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}  >
                                               <Icon style={{ fontSize: 16 }}>close</Icon>
                                           </IconButton>
                                       </div>
                                   }
                                </div>
                                    <Contents panel={p}/>
                                </Paper >
                           </Box>
                    );
                })}
            </div>
        );
    }
    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                ref={baseref}
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                uploaded={fileuploaded}
                entrycallback={MenuAction}
                condition={true}
                entryform={true}
                tabs={true}
                show={Show}
                primarykey={primarykeys}
                entrydataRef={entrydataRef}
                navmenu={entryNavMenu()}
                suppressaction={suppressaction}
                lockcell={ListlockCell}
                usecondition={true}
          >
            <EntryForm/>
            </MasterBase>
            <EntryLayout
                 columninfo={textfieldsall}
                 textfields={textfields} 
                 onAppry={SetLayout}
            />
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton size="small" onClick={() => fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <Headline columninfo={columninfo} entrydata={entrydataRef.current} hidden={panelhidden }></Headline>
                    <div style={{ position: 'absolute', top: 60, left: 210 }}>
                    <Paper
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexWrap: 'wrap',
                            listStyle: 'none',
                            p: 0.5,
                            m: 0,
                        }}
                        component="ul"
                        elevation={0}
                        style={{ backgroundColor: "transparent", width: panelnavwidth() }}
                    >
                            {/*Panel Selector*/}
                            <SortablePanelSelector
                                axis={"x"}
                                items={panel}
                                onSortEnd={onPanelSortEnd}
                                distance={2}
                             />
                    </Paper>
                    </div>
                </div>
                : null}
            <AGFunc ref={AGRef} />
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
        {/*    <DropZone*/}
        {/*        controller={controller}*/}
        {/*        code={edittingcode}*/}
        {/*        open={isDragActive}*/}
        {/*        onclose={FileDropClose}*/}
        {/*        actionurl={actionurl}*/}
        {/*        uploaded={fileuploaded}*/}
        {/*    />*/}
        </div>
    );
};

